import { onCleanup, onMount } from "solid-js";
import { gsap } from "gsap";

const LoadingIndicator = props => {
  let gifElement;

  console.log("props", props.isCategoriesIndicator);

  onMount(() => {
    // Set the rotation to a complete turn (360 degrees) without acceleration
    const animation = gsap.to(gifElement, {
      duration: 45, // Duration for a full rotation
      rotation: 360, // Complete rotation
      repeat: -1, // Repeat indefinitely
      ease: "linear", // Use linear easing for constant speed
    });

    onCleanup(() => {
      animation.kill();
    });
  });

  return (
    <div style={{ position: "absolute", "z-index": 9999 }}>
      <img
        ref={gifElement}
        src="https://i.ibb.co/93smZKNY/Chat-GPT-Image-Aug-26-2025-12-43-04-AM.png"
        alt="Animated GIF"
        width={"200"}
        height={"200"}
      />
    </div>
  );
};

export default LoadingIndicator;

